/** API query for a paged list: limit/offset plus the given filter keys that are set in the URL. */
export function pagedQuery(params: URLSearchParams, keys: readonly string[], limit: number, offset: number) {
  const query = new URLSearchParams({ limit: String(limit), offset: String(offset) });
  for (const k of keys) if (params.get(k)) query.set(k, params.get(k)!);
  return query;
}

/** ?offset= as a non-negative page offset (0 when missing or invalid). */
export const offsetParam = (params: URLSearchParams) => Number(params.get('offset') ?? 0) || 0;

/** True when any of the keys has a value. */
export const hasAnyParam = (params: URLSearchParams, keys: readonly string[]) => keys.some((k) => !!params.get(k));

/** `params` with `changes` applied (null deletes a key). */
export function withChanges(params: URLSearchParams, changes: Record<string, string | null>): URLSearchParams {
  const next = new URLSearchParams(params);
  for (const [k, v] of Object.entries(changes)) {
    if (v === null) next.delete(k);
    else next.set(k, v);
  }
  return next;
}

/** One known value from the URL, or '' (a hand-edited URL never 400s). */
export const oneOf = <T extends string>(v: string | null, all: readonly T[]): T | '' => (all.includes(v as T) ? (v as T) : '');
